import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 8l-4-4v3H3v2h15v3l4-4zM2 16l4 4v-3h15v-2H6v-3l-4 4z"
}), 'SyncAltTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SyncAltTwoTone.js
// module id = 6638
// module chunks = 2